import React, { useState } from 'react'
import { View, TouchableWithoutFeedback, ScrollView } from 'react-native'
import WebView from 'react-native-webview'
import PropTypes from 'prop-types'

import { VFText, VFButton, Icon, QuickActionMenu } from '@vfgroup-oneplatform/foundation/Components'
import VFLottieView from '@vfgroup-oneplatform/foundation/Components/VFLottieView'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'

import StoreInfo from '../../Components/StoreInfo'
import { formatDate } from '../../Utils/DateHelpers'
import { getStringsArrayFromPlaceholders } from '../../Utils/StringsHelpers'

import { getThemeImages } from '../../Themes/Modes'

import styles from './SummaryStep.styles'

const SummaryStep = ({
  service,
  store,
  date,
  formatAppointmentDate,
  onBookAppointmentPress,
  withTray,
  ...props
}) => {

  const theme = useTheme()
  const Images = getThemeImages(theme.name)

  const [termsModalState, setTermsModalState] = useState({
    isVisible: false,
    title: '',
    url: ''
  })

  const closeModal = () => {
    setTermsModalState(prev => ({ ...prev, isVisible: false }))
  }


  const onReturnPolicyPress = () => setTermsModalState(prev => ({
    ...prev,
    isVisible: true,
    title: 'book_appointment_summary_step_policy_modal_title',
    url: 'book_appointment_summary_step_policy_modal_url'
  }))

  const onTermsAndConditionsPress = () => setTermsModalState(prev => ({
    ...prev,
    isVisible: true,
    title: 'book_appointment_summary_step_terms_modal_title',
    url: 'book_appointment_summary_step_terms_modal_url'
  }))

  const helperTextArr = getStringsArrayFromPlaceholders('book_appointment_summary_step_terms', 2)

  const javascriptDark = `
   window.ReactNativeWebView.postMessage('test');
   window.document.querySelector('html, body').style.backgroundColor = 'rgb(51,51,51)';
   window.document.querySelector('p, h1, h2, body, spam, div').style.color = '#fff';
   true;
  `;


  return (
    <>
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={styles.container(withTray)}
      >
        <VFText i18nKey="book_appointment_summary_step_subtile" style={styles.title(theme)} />

        <View style={styles.cardContainerStyle(theme)}>
          <Icon name={Images[service?.serviceIcon]} size={100} style={styles.serviceTypeImageStyle} />

          <VFText>
            <VFText i18nKey={service?.title} style={styles.serviceTypeTextStyle(theme)} />
            <VFText i18nKey=" " style={styles.serviceTypeTextStyle(theme)} />
          </VFText>

          <StoreInfo {...(store || {})} style={styles.storeInfoContainerStyle} />

          <VFText
            i18nKey={formatDate(date?.selectedDate, date?.selectedTime, formatAppointmentDate)}
            style={styles.dateTextStyle(theme)}
          />

          {/* <View style={styles.helperTextContainerStyle}>
            <VFText style={styles.helperTextStyle(theme)}>
              <VFText i18nKey={helperTextArr[0]} />

              <TouchableWithoutFeedback onPress={onTermsAndConditionsPress}>
                <VFText
                  i18nKey="book_appointment_summary_step_terms_hyperlink_text"
                  style={styles.hyperLinkTextStyle}
                />
              </TouchableWithoutFeedback>

              <VFText i18nKey={helperTextArr[1]} />

              <TouchableWithoutFeedback onPress={onReturnPolicyPress}>
                <VFText
                  i18nKey="book_appointment_summary_step_privacy_hyperlink_text"
                  style={styles.hyperLinkTextStyle}
                />
              </TouchableWithoutFeedback>

              <VFText i18nKey={helperTextArr[2]} />
            </VFText>
          </View> */}

          <View style={styles.seperatorStyle(theme)} />

          <VFButton
            title="book_appointment_summary_cta_button_title"
            onPress={() => onBookAppointmentPress({ service, store, date, ...props })}
            style={styles.confirmButtonStyle}
          />
        </View>
      </ScrollView>
      <QuickActionMenu
        isVisible={termsModalState.isVisible}
        toggleModal={closeModal}
        title={termsModalState.title}
        type='secondary'
        headerStyle={styles.modalHeaderStyle}
      >
        <View
          onStartShouldSetResponder={() => true}
          style={styles.modalView}
        >
          <WebView
            source={{ uri: ContentManager.translate(termsModalState?.url) }}
            startInLoadingState={true}
            renderLoading={() => {
              return (
                <View style={styles.loadingContainer} >
                  <VFLottieView
                    autoPlay
                    style={styles.lottieStyle}
                  />
                </View>
              )
            }}
            originWhitelist={['*']}
            javaScriptEnabledAndroid={true}
            javaScriptEnabled={true}
            injectedJavaScript={theme.name === 'dark' ? javascriptDark : ''}
            injectedJavaScriptForMainFrameOnly={true}
            onMessage={() => { }}
            style={styles.webviewContainer}
          />
        </View>
      </QuickActionMenu>
    </>
  )
}

SummaryStep.propTypes = {
  service: PropTypes.shape({
    title: PropTypes.string.isRequired,
    image: PropTypes.shape({ uri: PropTypes.string }).isRequired,
  }).isRequired,
  store: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.shape({
      name: PropTypes.string,
    }),
    contactInfo: PropTypes.shape({
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
    }),
  }).isRequired,
  date: PropTypes.shape({
    selectedDate: PropTypes.string,
    selectedTime: PropTypes.string,
  }).isRequired,
  formatAppointmentDate: PropTypes.func,
  onBookAppointmentPress: PropTypes.func,
  withTray: PropTypes.bool,
}

export default SummaryStep
